export const ALLOW_VEHICLE_CHANGE_FLAG = "allow-vehicle-change"

// Chat kinds that hold a vehicle exclusively — see "Zajętość samochodu" in the
// account_config glossary. Only these chats are named after a vehicle and a
// driver, so only these can be missing both.
export const VEHICLE_OCCUPYING_GROUPS = ["driver", "double_crew"]

// Chat kinds the backend empties when a driver is seated elsewhere. Narrower
// than `VEHICLE_OCCUPYING_GROUPS` on purpose: a double crew chat holds its
// vehicle exclusively, but the backend never pulls a driver out of one, so the
// front must not promise it will.
export const DRIVER_SEATING_GROUPS = ["driver"]

// Chat kinds the backend clears a car out of when it's saved onto another
// chat. Same asymmetry as `DRIVER_SEATING_GROUPS`: double crew holds its
// vehicle exclusively, so picking it elsewhere is still refused, not cleared.
export const CAR_CLEARABLE_GROUPS = ["driver"]
